function akShowLoader(){
  if(!document.body.querySelector('.loader-overlay')){
    var div = document.createElement('div');
    div.className = 'loader-overlay';
    div.style.position = 'fixed';
    div.innerHTML = '<div class="loader"></div>';
    document.body.appendChild(div);
  }
}
function akHideLoader(){
  var el = document.body.querySelector('.loader-overlay');
  if(el) el.remove();
}

$(function(){
  function applyStyles() {
    const host = document.querySelector(
      '.kd-product-table section-store--shipping-info-block'
    );

    if (!host?.shadowRoot) return;

    const shadow = host.shadowRoot;

    if (shadow && !shadow.querySelector('#custom-hover-style')) {
    const style = document.createElement('style');
    style.id = 'custom-hover-style';

    style.textContent = `
      .body {
        transition: transform .3s ease;
      }

      .body:hover {
        transform: scale(1.05);
      }
    `;

    shadow.appendChild(style);
  }

    const body = shadow.querySelector('.body');
    const estimate = shadow.querySelector('.estimate-content');
    const indicator = shadow.querySelector('.indicator');
    const shipsBy = shadow.querySelector('.ships-by');
    const shippingType = shadow.querySelector('.shipping-type');
    const shippingTime = shadow.querySelector('.shipping-type strong');
    const shippingDate = shadow.querySelector('.shipping-date');

    if (window.innerWidth >= 800) {
      if (body) Object.assign(body.style, {
        flexDirection: 'column',
        borderWidth: '2.5px',
        padding: '30px 25px',
        background: '#fff',
        marginTop: '30px'
      });
      if (shippingDate) Object.assign(shippingDate.style, {
        color: '#c83636',
        fontSize: '25px',
        width: '45%',
        textAlign: 'center'
      });
      if (shipsBy) Object.assign(shipsBy.style, {
        fontSize: '20px',
        marginBottom: '20px',
        width: '80%',
        textAlign: 'center'
      });
      if (shippingType) Object.assign(shippingType.style, {
        color: '#000000',
        marginTop: '15px'
      });

      if (estimate) estimate.style.flexDirection = 'column';
      if (indicator) indicator.style.display = 'none';
      if (shippingTime) shippingTime.style.color ='#c83636';
    } else {
      if (body) Object.assign(body.style, {
        flexDirection: 'row',
        borderWidth: '7.5px',
        padding: '7px 6px',
        background: '#ebebeb',
        marginTop: 'unset'
      });
      if (shippingDate) Object.assign(shippingDate.style, {
        color: '#000000',
        fontSize: '20px',
        width: '100%',
        textAlign: 'left'
      });
      if (shipsBy) Object.assign(shipsBy.style, {
        fontSize: '17px',
        marginBottom: 'unset',
        width: '100%',
        textAlign: 'left'
      });
      if (shippingType) Object.assign(shippingType.style, {
        color: '#c83636',
        marginTop: 'unset'
      });
      if (estimate) estimate.style.flexDirection = 'row';
      if (indicator) indicator.style.display = 'flex';
      if (shippingTime) shippingTime.style.color ='#000000';
    }
  }

  window.addEventListener('load', applyStyles);
  window.addEventListener('resize', applyStyles);
  applyStyles();
});

(function(){
  /* ak start product page */
  $(document).on('click', '.product-form--atc-button.mdc-ripple-surface.mdc-ripple-upgraded', function(){
    akShowLoader()
    setTimeout(function(){
      akHideLoader();
      /* SFSX fix: removed synthetic click on [href="/cart"] — it forced a hard
         navigation to /cart after the drawer opened. Drawer opens on its own. */
    }, 2500);
  });

  // $(document).on('click', '.quantity-selector__button--plus, .quantity-selector__button--minus', function () {

  //   var $wrapper = $(this).closest('.quantity-selector');
  //   var $input   = $wrapper.find('.quantity-selector__input');
  //   var $minus   = $wrapper.find('.quantity-selector__button--minus');

  //   var value = parseInt($input.val(), 10) || 1;

  //   // PLUS
  //   if ($(this).hasClass('quantity-selector__button--plus')) {
  //     value++;
  //   }

  //   // MINUS
  //   if ($(this).hasClass('quantity-selector__button--minus') && value > 1) {
  //     value--;
  //   }

  //   $input.val(value).trigger('change');

  //   // Disable / enable minus
  //   $minus.prop('disabled', value <= 1);
  //   if(value <= 1){
  //     $minus.parent().addClass('quantity-selector__button-wrapper--disabled');   
  //   }else{
  //     $minus.parent().removeClass('quantity-selector__button-wrapper--disabled');   
  //   }
  // });   
  /* ak end product page */


// // --- Create a reusable modal container if not exists ---
// if ($('#QuickshopModal').length === 0) {
//     $('body').append(`
//         <div id="QuickshopModal" >
//             <div id="QuickshopModalContent" >
//                 <span id="QuickshopModalClose" style="position:absolute;top:10px;right:15px;font-size:26px;cursor:pointer;">&times;</span>
//                 <div id="QuickshopModalInner"></div>
//             </div>
//         </div>
//     `);

//     // Close modal on click
//     $(document).on('click', '#QuickshopModalClose', function(){
//       $('#QuickshopModal').fadeOut(()=>{
//         $('#QuickshopModal').remove();
//       });
//     });

//     // Close modal if click outside inner box
//     $('#QuickshopModal').on('click', function(e){
//         if(e.target.id === 'QuickshopModal'){
//             $(this).fadeOut();
//         }
//     });
// }

// // --- Handle Quickshop button click ---
$(document).on('click', '.productitem--action-trigger[data-quick-buy]', function() {
  var variantId = $(this).data('variant-id');
  var data = {
    id: variantId, // The variant ID (required)
    quantity: 1     // Number of items to add (change as needed)
  };
  $.ajax({
    type: 'POST',
    url: '/cart/add.js', // Shopify's endpoint for adding items to the cart
    data: data, // Send the product data (ID and quantity)
    dataType: 'json', // Expect JSON response
    success: function(response) {
      window.location.href = '/cart';
    },
    error: function(error) {
      // Handle any errors (e.g., product is out of stock)
      alert('There was an error adding the product to your cart.');
      console.error(error);
    }
  });
});


// $('[data-quickshop-slim], [data-quickshop-full]').off('click');
// $(document).on('click', '[data-quickshop-slim], [data-quickshop-full]', function(e){
//     e.preventDefault();

//     var targetUrl = $(this).parents('li.productgrid--item').find('[data-product-page-link]').attr('href');
//     if(!targetUrl){
//       console.log("targetUrl not found.");
//     }
//     $('#QuickshopModal').remove();
    
//       $('body').prepend(`
    
//         <div id="QuickshopModal" style="display: block;">
//             <div id="QuickshopModalContent">
//                 <span id="QuickshopModalClose" style="position:absolute;top:10px;right:15px;font-size:26px;cursor:pointer;">×</span>
//                 <div id="QuickshopModalInner"></div>
//             </div>
//         </div>  
//       `);
    

//     fetch(`${targetUrl}?view=quickshop`, {
//         method: 'get'
//     })
//     .then(r => r.text())
//     .then(html => {
//       const doc = new DOMParser().parseFromString(html, 'text/html');
//       const content = doc.querySelector('#site-main');

//       console.log("siteMainHtml", content); // ✅ WORKS
//       $('#QuickshopModalInner').html($(content).html());
//       $('#QuickshopModalInner').fadeIn();

//       $('#QuickshopModalInner img').each(function(){
//         var rimgTemplateAK = $(this).data('rimg-template');
//         console.log("86 > data-quickshop-slim"+rimgTemplateAK);

//         if(typeof rimgTemplateAK != 'undefined'){
//           var newSrcAK = rimgTemplateAK.replace(`{size}`, '720x');
//           newSrcAK = "https:"+newSrcAK;
//           $(this).attr('src', newSrcAK);
//           $(this).removeAttr('data-rimg');
//           $(this).removeAttr('srcset');
//           $(this).removeAttr('data-rimg-scale');
//           $(this).removeAttr('data-rimg-template');
//           $(this).removeAttr('data-rimg-max');
//           $(this).removeAttr('data-rimg-crop');
//         }
//       });
//       $('#QuickshopModalInner .quantity-selector__button-wrapper--minus, #QuickshopModalInner .quantity-selector__button-wrapper--plus').off('click');

//       $('#QuickshopModalInner .quantity-selector__button-wrapper--minus').on('click', function (e) {
//           var cVal = parseInt($('#QuickshopModalInner [name="quantity"]').val());
//           cVal--;
//           if(cVal<=0){
//               cVal = 1;
//           }
//           $('#QuickshopModalInner [name="quantity"]').val(cVal);
//       });

//       $('#QuickshopModalInner .quantity-selector__button-wrapper--plus').on('click', function (e) {
//           var cVal = parseInt($('#QuickshopModalInner [name="quantity"]').val());
//           cVal++;
//           if(cVal<=0){
//               cVal = 1;
//           }
//           $('#QuickshopModalInner [name="quantity"]').val(cVal);
//       });

//       if(typeof Flickity === 'function'){
//           $('#QuickshopModalInner .flickity').each(function(){
//               new Flickity(this, $(this).data('flickity') || {});
//           });
//       }
//     })
//     .catch(err => console.error('Quickshop load error:', err));
// });


        // Small utility functions and safe event wiring. Avoid blocking calls.

        // Ensure jQuery is available; if not, use a small fallback to avoid errors.
        function ready(fn){
          if(window.jQuery) {
            jQuery(document).ready(fn);
          } else if (document.readyState === 'complete' || document.readyState === 'interactive') {
            setTimeout(fn, 0);
          } else {
            document.addEventListener('DOMContentLoaded', fn);
          }
        }


        ready(function(){
          
          const params = new URLSearchParams(window.location.search);

          // Check if view=compare
          if (params.get('view') === 'compare') {
            
            // Create style tag
            const style = document.createElement('style');
            style.innerHTML = `
              [data-live-search] > form > div:nth-child(1){
                flex-wrap: unset !important;
              }
                button.live-search-button+#product-restore-quote{
                  display: none !important;
                }
            `;

            // Append to head
            document.head.appendChild(style);
          }


          // Wrap existing logic but avoid deprecated/blocked patterns (no async:false, no heavy sync operations)
          
          function applyInsulatedShippingClass() {
            if(!window.jQuery) return;
            jQuery('.cart-item').each(function () {
                const titleText = jQuery(this).find('.cart-item--content-title a').text().toLowerCase().trim();
                if (titleText.includes('insulated shipping')) {
                    jQuery(this).addClass('insulated-shipping-item');
                }
            });
          }

          async function updateInsulatedShippingBox(triggeredByQtyChange = false) {
              akShowLoader();
              try {

                const cartRes = await fetch('/cart.js');
                const cart = await cartRes.json();

                // Exclude insulated shipping product from weight calculations
                const filteredItems = cart.items.filter(item =>
                    !(item.title && item.title.toLowerCase().includes("insulated shipping") || item.handle === "insulated-shipping")
                );

                const totalWeightGrams = filteredItems.reduce((sum, item) => sum + (item.grams || 0) * item.quantity, 0);
                const weightLb = totalWeightGrams * 0.00220462;
                const roundedWeight = Math.ceil(weightLb || 0);

                let units = Math.floor(roundedWeight / 44);
                if (roundedWeight % 44 > 0) units += 1;

                const surcharge = 26.51;
                const shipPrice = (units * surcharge).toFixed(2);
                const packagingWeight = units * 8;
                const totalShippingWeight = roundedWeight + packagingWeight;

                const box = document.querySelector('.chocolate-shipping-box');
                if(box){
                  box.setAttribute('data-weight', roundedWeight);
                  box.setAttribute('data-shipping-price', shipPrice);
                  var priceEl = box.querySelector('.choco-price');
                  if(priceEl) priceEl.textContent = `$${shipPrice} for your ${roundedWeight} lb order.`;
                }

                const cartItemEl = document.querySelector('[data-cartitem-id="46163232882946"]');
                if(cartItemEl){
                  var moneySpan = cartItemEl.querySelector('span.money');
                  if(moneySpan) moneySpan.textContent = `$${shipPrice}`;
                }

                applyInsulatedShippingClass();

                const insulatedItem = cart.items.find(item =>
                    (item.title && item.title.toLowerCase().includes("insulated shipping")) || item.handle === "insulated-shipping"
                );

                if (insulatedItem) {
                    const insulatedId = insulatedItem.id;
                    var selector = `.cart-item[data-cartitem-id="${insulatedId}"]`;
                    var el = document.querySelector(selector);
                    if(el){
                      var qty = el.querySelector('.cart-item__quantity'); if(qty) qty.style.display='none';
                      var tot = el.querySelector('.cart-item__total'); if(tot) tot.style.display='none';
                    }
                    var checkbox = document.getElementById('insulated-shipping'); if(checkbox) checkbox.checked = true;

                    if (triggeredByQtyChange) {
                      // Safe: send lightweight update (no blocking sync ajax)
                      sendInsulatedShippingUpdate(roundedWeight, shipPrice).catch(function(e){ console.error(e); });
                    }
                } else {
                    var csb = document.querySelector('.chocolate-shipping-box'); if(csb) csb.style.display='block';
                    var checkbox = document.getElementById('insulated-shipping'); if(checkbox) checkbox.checked = false;
                }

              } catch(err){
                console.error('Failed to update shipping box:', err);
              } finally {
                akHideLoader();
              }
          }

          function akAppendInsulatedHtml(){
              console.log("insulated 191");
              var akHtml = `
                    <div class="amp-cart__cart-line">
                        <div
                          class="chocolate-shipping-box "
                          data-weight="1"
                          data-shipping-price="26.51"
                        >
                          <div class="choco-header">
                            <img
                              src="https://icons.iconarchive.com/icons/jommans/cafe-noon/128/chocolate-icon.png"
                              alt="Chocolate"
                              class="choco-icon"
                            >

                            <div>
                              <p class="choco-title">Warm out there? Protect your chocolate!</p>
                              <p class="choco-desc">
                                Add insulated shipping to ensure your delicious treats arrive in perfect condition.
                                <span class="choco-price">$26.51 for your 1 lb order.</span>
                              </p>
                              
                            </div>
                          </div>

                          <label class="choco-checkbox">
                            <input
                              type="checkbox"
                              id="insulated-shipping"
                              name="attributes[Insulated Shipping]"
                              value="Yes"
                              data-gtm-form-interact-field-id="0"
                            >
                            <strong>Add Insulated Shipping Protection: <i>Please click only when your cart is ready to check out. This will immediately redirect you to the checkout page.</i></strong>
                          </label>

                          <div class="choco-warning">
                            <div style="color: #ff3131;">
                              ⚠️ For Orders Over 150 lbs ⚠️ Insulated shipping is unavailable at checkout for orders exceeding 150 lbs. Please contact us for a custom quote and shipping options.
                            </div>
                            <br>
                            <div style="color: #ff3131;">
                              ⚠️For best results, place chocolate orders separately to better control shipping speed and costs for non-insulated items.⚠️
                            </div>
                          </div>
                        </div>
                    </div>

              `; 
              if(!$('.amp-cart__header.amp-cart__header--tall+.chocolate-shipping-box').get(0)){
                $(akHtml).insertAfter('.amp-cart__header.amp-cart__header--tall');
              }

              if(!$('.amp-cart__footer-cart-button').get(0)){
                $('.amp-button.amp-cart__footer-checkout-button').hide();
                $('<a href="/cart" class="amp-button amp-cart__footer-checkout-button amp-cart__footer-cart-button false">Cart</a>').insertAfter('.amp-button.amp-cart__footer-checkout-button');
              }


          } // akAppendInsulatedHtml

          var akManageInsulatedContainerDisplayTimer = null;
          var akTmpTitle = '';
          var hasInsulatedShipping = false;
          function akManageInsulatedContainerDisplay(){
              if(akManageInsulatedContainerDisplayTimer != null){
                  clearTimeout(akManageInsulatedContainerDisplayTimer);
              }
              hasInsulatedShipping = false;
              $('.amp-cart__cart-lines > .amp-cart__cart-line').each(function(){
                  akTmpTitle = $(this).find('.amp-cart__cart-line-title').text();
                  if(akTmpTitle.includes("Insulated Shipping Kit (Add On)")){
                    $(this).find('.amp-cart__line-quantity-selector').css('visibility', 'hidden');  
                    hasInsulatedShipping = true;
                  }
              });
              if(hasInsulatedShipping){
                  $('.chocolate-shipping-box').parent().hide();
              }else{
                  if($('.chocolate-shipping-box').parent().css('display') == 'none'){
                    $('#insulated-shipping').prop('checked', false)
                  }
                  
                  $('.chocolate-shipping-box').parent().fadeIn();
              }

              akManageInsulatedContainerDisplayTimer = setTimeout(function(){
                  akManageInsulatedContainerDisplay();
              }, 1000);
          }

          setTimeout(function(){
            akAppendInsulatedHtml();
            akManageInsulatedContainerDisplay();
          }, 2500);

          async function sendInsulatedShippingUpdate(weight, shippingPrice) {
            try{
              akShowLoader();
              const payload = {
                insulated: true,
                source: window.location.href,
                weight: weight + 'lb',
                price: shippingPrice
              };

              const resp = await fetch('https://lightgrey-butterfly-351538.hostingersite.com/index.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
              });

              const response = await resp.json();

              if (response.variants && response.variants.length > 0) {
                const newVariant = response.variants.find(v => v.option1 && v.option1.toLowerCase() === 'insulated');
                if (!newVariant) {
                  console.warn('No insulated variant found');
                  return;
                }

                // Use cart.js to inspect and then add/update using Shopify endpoints (fetch)
                const cartRes = await fetch('/cart.js');
                const cart = await cartRes.json();

                const insulatedItem = cart.items.find(item =>
                  item.variant_id === newVariant.id || (item.title && item.title.toLowerCase().includes('insulated shipping'))
                );

                if (insulatedItem) {
                  // Update properties via change.js
                  await fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
                    body: `id=${encodeURIComponent(insulatedItem.key)}&quantity=1`
                  });
                } else {
                  // Add new item
                  await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: newVariant.id, quantity: 1 })
                  });
                }
              } else {
                console.warn('No variants returned from insulated endpoint');
              }

            } catch(err){
              console.error('Failed sending insulated update:', err);
            } finally {
              akHideLoader();
            }
          }

          // Wire events (debounced) for quantity changes and checkbox
          (function(){
                        
            var qtyTimer;
            document.addEventListener('click', function(e){
              if(e.target.closest('[data-quantity-plus]') || e.target.closest('[data-quantity-minus]')){
                clearTimeout(qtyTimer);
                qtyTimer = setTimeout(function(){ updateInsulatedShippingBox(true); }, 600);
              }
            }, true);

            document.addEventListener('change', function(e){
              if(e.target.closest('[data-quantity-input]')){
                clearTimeout(qtyTimer);
                qtyTimer = setTimeout(function(){ updateInsulatedShippingBox(true); }, 600);
              }
            }, true);
            document.addEventListener('change', function(e){
              if (e.target && e.target.id === 'insulated-shipping') {
                var insulatedCheckbox = document.getElementById('insulated-shipping');
                var isChecked = insulatedCheckbox.checked;
                var box = document.querySelector('.chocolate-shipping-box');
                var weight = box ? box.getAttribute('data-weight') : 0;
                var price = box ? box.getAttribute('data-shipping-price') : 0;
                if(isChecked){
                  akShowLoader();
                  fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: 47701012414722, quantity: 1 })
                  }).then(function(){ 
                    akHideLoader();
                    // window.location.href = '/cart'; 
                  });
                }
                /*
                akShowLoader();
                fetch('https://lightgrey-butterfly-351538.hostingersite.com/index.php', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ insulated: isChecked, source: window.location.href, weight: weight + 'lb', price: price })
                }).then(function(resp){ return resp.json(); }).then(function(response){
                  if (response.variants && response.variants.length > 0) {
                    var insulatedVariant = response.variants.find(function(v){ return v.option1 && v.option1.toLowerCase() === 'insulated'; });
                    if (isChecked && insulatedVariant) {
                      fetch('/cart/add.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ id: insulatedVariant.id, quantity: 1 })
                      }).then(function(){ window.location.href = '/checkout'; });
                    } else {
                      setTimeout(function(){ updateInsulatedShippingBox(); window.location.reload(); }, 800);
                    }
                  } else {
                    akHideLoader();
                  }
                }).catch(function(err){ console.error(err); akHideLoader(); });
                */
              }
            }, true);

            // Run initial sync
            updateInsulatedShippingBox(false);

          })();

        }); // ready
      })();

        // setTimeout(function(){
          $(function(){
              

              $('img').each(function(){
                var rimgTemplateAK = $(this).data('rimg-template');
                if(typeof rimgTemplateAK != 'undefined'){
                  var newSrcAK = rimgTemplateAK.replace(`{size}`, '720x');
                  newSrcAK = "https:"+newSrcAK;
                  $(this).attr('src', newSrcAK);
                  $(this).removeAttr('data-rimg');
                  $(this).removeAttr('srcset');
                  $(this).removeAttr('data-rimg-scale');
                  $(this).removeAttr('data-rimg-template');
                  $(this).removeAttr('data-rimg-max');
                  $(this).removeAttr('data-rimg-crop');
                }
              });
              $('.pxs-image-with-text-background').each(function(){
                var rimgTemplateAK = $(this).data('rimg-template');
                  var newSrcAK = rimgTemplateAK.replace(`{size}`, '720x');
                  newSrcAK = "https:"+newSrcAK;
                  $(this).css({
                    'background-image': `url('${newSrcAK}')`,
                  });
              });
              $('.promo-block img, .productgrid--item.featured-collection__title-card.featured-collection__title-card--horizontal-size- img').each(function(){
                $(this).css({
                  'opacity': 1,
                  'height': '100%',
                  'width': '100%'
                });
              });
              
            // setTimeout(function(){
            
                $('noscript').each(function () {

                    // Read everything inside the <noscript>
                    const content = $(this).html();
                    const temp = $('<div>').html(content);

                    temp.find('script').each(function () {

                        const src = $(this).attr('src');
                        const inline = $(this).html().trim();

                        // ---------- external JS file ------------
                        if (src) {
                            const script = document.createElement('script');
                            script.src = src;
                            document.body.appendChild(script);
                        }

                        // ---------- inline JS code ------------
                        else if (inline) {
                            const script = document.createElement('script');
                            script.text = inline;
                            document.body.appendChild(script);
                        }

                    });

                }); 

                // Load Slick CSS
                function loadCSS(href) {
                    const link = document.createElement('link');
                    link.rel = 'stylesheet';
                    link.href = href;
                    document.head.appendChild(link);
                }

                function initSlickSlider() {
                  
                    $('[data-slideshow-wrapper]').slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        autoplay: true,
                        autoplaySpeed: 4000,
                        arrows: true,
                        dots: true,
                        fade: true,
                        adaptiveHeight: true
                    });

                    $('.home-section--content.blogposts--inner').slick({
                      slidesToShow: 3,
                      slidesToScroll: 1,
                      infinite: false,
                      dots: false,
                      arrows: false,

                      responsive: [
                        {
                          breakpoint: 1024, // tablets landscape
                          settings: {
                            slidesToShow: 3
                          }
                        },
                        {
                          breakpoint: 768, // tablets portrait
                          settings: {
                            slidesToShow: 2
                          }
                        },
                        {
                          breakpoint: 480, // mobile
                          settings: {
                            slidesToShow: 1
                          }
                        }
                      ]
                    });
                    //
                    $('.testimonials.testimonials--large.home-section--content, .highlights-banner__content.highlight-banner__count-4').slick({
                      slidesToShow: 4,
                      slidesToScroll: 1,
                      infinite: false,
                      dots: false,
                      arrows: false,

                      responsive: [
                        {
                          breakpoint: 1024, // tablets landscape
                          settings: {
                            slidesToShow: 4
                          }
                        },
                        {
                          breakpoint: 768, // tablets portrait
                          settings: {
                            slidesToShow: 2
                          }
                        },
                        {
                          breakpoint: 480, // mobile
                          settings: {
                            slidesToShow: 1
                          }
                        }
                      ]
                    });
                    if (window.innerWidth <= 1024) {
                      $('.featured-collection__content').slick({
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        infinite: false,
                        dots: false,
                        arrows: false,

                        responsive: [
                          {
                            breakpoint: 1024, // tablets landscape
                            settings: {
                              slidesToShow: 3
                            }
                          },
                          {
                            breakpoint: 768, // tablets portrait
                            settings: {
                              slidesToShow: 2
                            }
                          },
                          {
                            breakpoint: 480, // mobile
                            settings: {
                              slidesToShow: 2
                            }
                          }
                        ]
                      });
                    }

                    
                }


              // loadCSS("https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.css");
              // loadCSS("https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick-theme.css");

              // // Load Slick JS
              // var script = document.createElement('script');
              // script.src = "https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js";
              
              // script.onload = function() {
              //     initSlickSlider();
              // };
              // document.body.appendChild(script);

              // fix video 
              $('div.youtube').each(function(){
                var akYoutubeLink = $(this).data('video-url');
                var akYoutubeId = new URL(akYoutubeLink).searchParams.get("v");
                console.log("akYoutubeId", akYoutubeId);
                var akYoutubeEmbedLink = `https://www.youtube.com/embed/${akYoutubeId}?autoplay=0&mute=1`;
                $(this).html(`
                  <iframe
                    width="100%" 
                    src="${akYoutubeEmbedLink}" 
                    frameborder="0" 
                    allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                    allowfullscreen>
                  </iframe>
                `);
              });

            // }, 2500);
          });
        // }, 2500);



